/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    PaymentMethodToJSONTyped,
} from './PaymentMethod';

/**
 * 
 * @export
 * @interface CreditNoteSummary
 */
export interface CreditNoteSummary {
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof CreditNoteSummary
     */
    creditNoteNumber: HeoTransactionNumber;
    /**
     * 
     * @type {Date}
     * @memberof CreditNoteSummary
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof CreditNoteSummary
     */
    amount: number;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof CreditNoteSummary
     */
    refundMethod: PaymentMethod;
    /**
     * 
     * @type {Date}
     * @memberof CreditNoteSummary
     */
    refundedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreditNoteSummary
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreditNoteSummary
     */
    hasDocument: boolean;
}



/**
 * Check if a given object implements the CreditNoteSummary interface.
 */
export function instanceOfCreditNoteSummary(value: object): value is CreditNoteSummary {
    if (!('creditNoteNumber' in value) || value['creditNoteNumber'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('refundMethod' in value) || value['refundMethod'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('hasDocument' in value) || value['hasDocument'] === undefined) return false;
    return true;
}

export function CreditNoteSummaryFromJSON(json: any): CreditNoteSummary {
    return CreditNoteSummaryFromJSONTyped(json, false);
}

export function CreditNoteSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditNoteSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'creditNoteNumber': HeoTransactionNumberFromJSON(json['creditNoteNumber']),
        'createdAt': (new Date(json['createdAt'])),
        'amount': json['amount'],
        'refundMethod': PaymentMethodFromJSON(json['refundMethod']),
        'refundedAt': json['refundedAt'] == null ? undefined : (new Date(json['refundedAt'])),
        'description': json['description'],
        'hasDocument': json['hasDocument'],
    };
}

export function CreditNoteSummaryToJSON(json: any): CreditNoteSummary {
    return CreditNoteSummaryToJSONTyped(json, false);
}

export function CreditNoteSummaryToJSONTyped(value?: CreditNoteSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'creditNoteNumber': HeoTransactionNumberToJSON(value['creditNoteNumber']),
        'createdAt': value['createdAt'].toISOString(),
        'amount': value['amount'],
        'refundMethod': PaymentMethodToJSON(value['refundMethod']),
        'refundedAt': value['refundedAt'] == null ? value['refundedAt'] : value['refundedAt'].toISOString(),
        'description': value['description'],
        'hasDocument': value['hasDocument'],
    };
}

